import { Dashboard } from '@uppy/react';
import React from 'react';
import classes from './CommentsUppy.module.css';
import useUploadFiles from 'containers/Uppy/useUploadFiles';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import 'assets/custom-riza-plugin-styles/uppy-comments.css';

const CommentsUppy = (props) => {
  const { uppyRef } = useUploadFiles('comment', props.commentType, props.close);

  const uppyContainerClasses = [classes.UppyDashboardContainer];
  if (props.commentForm) {
    uppyContainerClasses.push(classes.CommentForm);
  }
  return (
    <div className={uppyContainerClasses.join(' ')}>
      {uppyRef.current && (
        <Dashboard
          {...props}
          uppy={uppyRef.current}
          debug={false}
          thumbnailWidth={94}
          thumbnailHeight={94}
          height={350}
          width={400}
          theme="dark"
          inline
          hideCancelButton
          trigger="#uppy-select-files"
          proudlyDisplayPoweredByUppy={false}
          showProgressDetails
          metaFields={[]}
          locale={{
            strings: {
              uploadComplete: 'Upload Succesful',
              xFilesSelected: { 0: '%{smart_count} Image Selected', 1: '%{smart_count} Images Selected' },
            },
          }}
        />
      )}
    </div>
  );
};

export default CommentsUppy;
